import Vue from 'vue'

// 引入 css
import './lib/css/reset.css'
import dpubWidget from '@didi/dpub-widget-thanos/lib/kpubGroup/h5'
import '@didi/dpub-widget-thanos/lib/kpubGroup/h5/index.css'
import { genRenderFnForH5 } from '@didi/dpub-render'
import promotionWidget from '@didi/xpub_es_promotion/dist/h5'
import '@didi/xpub_es_promotion/dist/h5/index.css'

import * as eventActions from './lib/js/event/index'
import getData from './lib/js/initData'
import { getLoginInfofromApp, checkIsVip, checkUserInfo, setShare } from './lib/js/common/connectApp'
import { mountUserinfo, initPartnerSet, setShareConfig } from './lib/js/common/recommendCom'
import { getQueryString, refreshPageByBack } from './lib/js/common/utils'
// import App from './App.vue'
import agility from './lib/js/utils'
import store from './store/index'
import raven from '@didi/raven'
// 引入 pageview 插件
import ravenPageViewPlugin from '@didi/raven/dist/plugins/pageview'
// 引入 error 插件
import ravenErrorPlugin from '@didi/raven/dist/plugins/error'
// 引入 performance 插件
import ravenPerformancePlugin from '@didi/raven/dist/plugins/performance'

raven.setConfig({ appId: 1524 })
// 安装 pageview 插件
raven.use(ravenPageViewPlugin)
// 安装 error 插件
raven.use(ravenErrorPlugin)
// 安装 performance 插件
raven.use(ravenPerformancePlugin)

window.$raven = raven

Vue.use(dpubWidget)

window.D = K
window.D.is = K.web.is
refreshPageByBack()
// console.log('NODE_ENV', process.env.NODE_ENV)
// 准备渲染数据。开发环境下返回 mock 数据，生产环境将替换真实数据。
getData().then((res) => {
  if (K.web.is('passenger')) {
    window.D.bridge.setTitle(res.title)
  } else {
    agility.setTitle(res.title)
  }

  const {
    // title,
    global
  } = res
  window.Coupon = {}
  // console.log(res)
  res.scenes.layers.map(function (item, index) {
    if (item.key === 'XpubespromotionEsPromotionStrategy') {
      window.pageType = 'recommendPage'
      window.strategyId = res.businessData.testButton
      window.recommend_business_line = item.props.recommend_business_line
    }
    if (item.key === 'XpubespromotionEsPromotionRecommentbtn') {
      window.shareUrl = item.props.shareUrl
    }
    if (item.key === 'XpubespromotionEsPromotionCoupondraw') {
      window.Coupon.listId = res.businessData.couponListKey
    }
  })
  // agility.setTitle(title)
  // window 数据挂载……
  window.__DomData = res
  window.__shareData = agility.setGlobalData(res)
  // const shareData = agility.setGlobalData(res)

  if (global.canShare) {
    if (window.pageType === 'recommendPage' || window.navigator.userAgent.toLocaleLowerCase().indexOf('didies') > -1) {
      console.log('推荐有奖页面或者滴滴企业版打开')
    } else {
      // K.setShare(shareData)
    }
  } else {
    // 关闭分享...
    K.setShare(false)
  }
    // 设置登录
  K.setLoginConfig({
    loginType: 'trinity'
  })
  window.__EVENT_ACTIONS = eventActions

  // 生成渲染函数
  const renderFn = genRenderFnForH5(res, { ...dpubWidget, ...promotionWidget })
  // eslint-disable-next-line
  new Vue({
    el: '#app',
    store,
    render: h => h('div', {
      props: res
    }, [
      // 先渲染Dpub的组件
      renderFn(h)
      // 插入其他业务组件
      // h(App, {
      //     props: res
      // })
    ]),
    created: function () {
      // `this` 指向 vm 实例
      // console.log('a is: ' + this.a)
      // console.log('window.E.partnerId', window.E.partnerId, this.$store.state.partnerId)
      if (window.pageType === 'recommendPage') {
        // console.log('23232323----23232323')
        getLoginInfofromApp().then(mountUserinfo).then(initPartnerSet).then(setShareConfig).then((res) => {
          if (res) {
            this.$store.commit('setPartnerId')
            this.$store.commit('setAccountNum')
            console.log('window.E.partnerId----------', window.E.partnerId, this.$store.state.partnerId)
          }
          const utmSource = getQueryString().dchn ? getQueryString().dchn : 'nosource'
          const pageId = getQueryString().s ? getQueryString().s : 'noId'
          Omega && Omega.setConfig({ attrs: { pub_marketing_dchn: utmSource, pub_marketing_pid: window.Info.uid, pub_marketing_cid: window.Info.companyId } })
          if (Omega && Omega.trackEvent) {
            Omega.trackEvent('es_moongazing_xpubedit_sw', '望月-活动工具-点击页面-展现',
              { channel_id: utmSource, id: pageId, uid: window.Info.uid }
            )
          }
        })
      } else {
        console.log('1111')
        getLoginInfofromApp().then(checkIsVip).then(checkUserInfo).then(() => {
          // eslint-disable-next-line
          if (!getQueryString().pageType || (getQueryString().saleSource &&  getQueryString().pageType != 6)) {
            setShare()
          }
        })
        .then(() => {
          const utmSource = getQueryString().dchn ? getQueryString().dchn : 'nosource'
          const pageId = getQueryString().s ? getQueryString().s : 'noId'
          Omega && Omega.setConfig({ attrs: { pub_marketing_dchn: utmSource, pub_marketing_pid: window.Info.uid, pub_marketing_cid: window.Info.companyId } })
          if (Omega && Omega.trackEvent) {
            Omega.trackEvent('es_moongazing_xpubedit_sw', '望月-活动工具-点击页面-展现',
              { channel_id: utmSource, id: pageId, uid: window.Info.uid }
            )
          }
        })
      }
    }
  })
})
